import FooterNewsletterSignupModal from './code/Scripts/Components/footer-newsletter-signup-modal.vue';

export default {
  components: {
    FooterNewsletterSignupModal,
  },
};
